var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 106,
    viewBox: "0 0 59 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1697)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.421 25.76c0-5.28-2.4-7.68-6.72-7.68s-6.48 2.52-6.48 7.68v15.6c0 5.4 2.28 7.92 6.6 7.92 4.08 0 6.6-2.64 6.6-7.68V25.76zm-13.44 36.72h-.6c-9.96 0-15.12-7.2-15.12-17.64V25.4c0-12.24 4.68-21 21-21h2.88c15.6 0 21.24 8.4 21.24 21v50.04c0 11.16-4.44 20.16-20.04 20.16h-3c-16.32 0-20.04-7.8-20.04-19.2v-7.2h15.84v5.76c0 4.68 1.32 6.96 5.64 6.96 4.08 0 5.64-2.28 5.64-7.2v-19.8c-1.2 1.92-5.28 7.56-13.44 7.56z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.421 25.76c0-5.28-2.4-7.68-6.72-7.68s-6.48 2.52-6.48 7.68v15.6c0 5.4 2.28 7.92 6.6 7.92 4.08 0 6.6-2.64 6.6-7.68V25.76zm-13.44 36.72h-.6c-9.96 0-15.12-7.2-15.12-17.64V25.4c0-12.24 4.68-21 21-21h2.88c15.6 0 21.24 8.4 21.24 21v50.04c0 11.16-4.44 20.16-20.04 20.16h-3c-16.32 0-20.04-7.8-20.04-19.2v-7.2h15.84v5.76c0 4.68 1.32 6.96 5.64 6.96 4.08 0 5.64-2.28 5.64-7.2v-19.8c-1.2 1.92-5.28 7.56-13.44 7.56z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1697",
    x: -4.239,
    y: -4.1,
    width: 63.12,
    height: 109.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1697",
    result: "effect2_dropShadow_2805_1697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1697",
    result: "shape"
  })))));
}
Svg9.displayName = '9';
export default Svg9;